/* @jsxImportSource react */

/**
 * EnergyEfficiencyIconOld component.
 *
 * Styling has to be completely managed by the parent component and passed via `className` param.
 */
export const LegacyEnergyEfficiencyFlagIcon = ({ className }: { className: string }) => (
  <svg
    className={className}
    id="Ebene_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 35 20"
  >
    <path fill="currentColor" d="M8.9,0h26.1v20H8.9L0,9.6,8.9,0Z" />
  </svg>
);

LegacyEnergyEfficiencyFlagIcon.displayName = 'EnergyEfficiencyIconOld';
